import { render, staticRenderFns } from "./WhyChooseUs.vue?vue&type=template&id=589b9517&scoped=true"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js"
import style0 from "./WhyChooseUs.vue?vue&type=style&index=0&id=589b9517&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b9517",
  null
  
)

export default component.exports